module.exports = __webpack_public_path__ + "static/media/cp3in.96cd64ff.png";